import {IImageAdaptiveMap} from 'modules/images/types';

export const MOBILE_BANNER_MAP: IImageAdaptiveMap = {
    screenWidth: 0,
    urlScreenVariant: 'urlMobile',
};
